import React from "react";
import { Statistic } from "antd";

const SbStatistic = (props) => {
    return <Statistic {...props} />;
};

export default SbStatistic;
